const AUTOPLAY_SPEED = 5000;

export default class BigSlider {
	constructor(params){
		this.el = params.el;
		if (!this.el) return false;
		this._init()
	}

	_init(){
		$(this.el).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: AUTOPLAY_SPEED,
			dots: true,
			mobileFirst: true,
			infinite: true,
			prevArrow: document.querySelector('[data-big-slider-prev]'),
			nextArrow: document.querySelector('[data-big-slider-next]'),
			dotsClass: 'big-slider__dots',
			customPaging: function(slider, i) {
				return ''
			}
		})
	}
}
